<template>
  <div class="panel-control" id="UserSelector">
    <!--Nav tabs-->
    <ul class="nav nav-tabs">
      <li :class="{ active: currentValue.type == 0 }">
        <a data-index="0" data-toggle="tab" href="#Roles" aria-expanded="true"
          >按角色选择</a
        >
      </li>
      <li :class="{ active: currentValue.type == 1 }">
        <a data-index="1" data-toggle="tab" href="#Users" aria-expanded="false"
          >按人员选择</a
        >
      </li>
    </ul>

    <!--Tabs Content-->
    <div class="tab-content">
      <div
        id="Roles"
        class="tab-pane fade"
        :class="{ active: currentValue.type == 0, in: currentValue.type == 0 }"
      >
        <div class="flex-checkboxs">
          <div class="checkbox" v-for="role in roles">
            <input
              :id="'Role' + role.id"
              class="magic-checkbox"
              type="checkbox"
              :value="role.id"
              :checked="checked(0, role.id)"
              @click="checkChanged()"
            />
            <label :for="'Role' + role.id">{{ role.name }}</label>
          </div>
        </div>
      </div>
      <div
        id="Users"
        class="tab-pane fade"
        :class="{ active: currentValue.type == 1, in: currentValue.type == 1 }"
      >
        <div class="flex-checkboxs">
          <div class="checkbox" v-for="user in users" :key="user.id">
            <input
              :id="'User' + user.id"
              class="magic-checkbox"
              type="checkbox"
              :value="user.id"
              :checked="checked(1, user.id)"
              @click="checkChanged()"
            />
            <label :for="'User' + user.id">{{ user.name }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTaskUsers, roles } from '@/service/getData'
import { parse } from 'path'

export default {
  props: ['value'],
  data() {
    return {
      users: [],
      roles: [],
      currentValue: this.value || {
        type: 0,
        values: [],
      },
    }
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  created() {
    this.requestUsers()
  },
  mounted() {
    let _this = this
    $('#UserSelector .nav-tabs a').on('show.bs.tab', function (e) {
      _this.currentValue.type = parseInt($(e.target).data('index'))
      _this.checkChanged()
      _this.currentValue.values = []
    })
  },
  methods: {
    async requestUsers() {
      let res = await getTaskUsers()
      this.users = res.data.list

      res = await roles()
      this.roles = res.data.list
    },
    formatData() {
      this.users.map((item) => {
        item.roles.map((role) => {})
      })
    },
    checked(type, value) {
      if (type != this.currentValue.type) {
        return false
      }

      return this.currentValue.values.includes(value)
    },
    checkChanged() {
      let container
      if (this.currentValue.type == 0) {
        container = '#Roles'
      } else {
        container = '#Users'
      }

      var values = []
      $(container + ' input[type=checkbox]:checked').each(function (e) {
        values.push(parseInt($(this).val()))
      })

      this.$emit('change', {
        type: this.currentValue.type,
        values: values,
      })
    },
  },
}
</script>

<style scoped>
.tab-content {
  padding-top: 20px;
}

.panel-control {
  width: 100%;
}

.flex-checkboxs {
  display: flex;
  flex-wrap: wrap;
}
.checkbox {
  width: 25%;
}
</style>